import { render, staticRenderFns } from "./RecommendLog.vue?vue&type=template&id=04bc34e6&scoped=true"
import script from "./RecommendLog.vue?vue&type=script&lang=js"
export * from "./RecommendLog.vue?vue&type=script&lang=js"
import style0 from "./RecommendLog.vue?vue&type=style&index=0&id=04bc34e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc34e6",
  null
  
)

export default component.exports